/**
 * Met la première lettre du texte en majuscule
 */
export function txtCapitalize(value: string): string {
    return value.charAt(0).toUpperCase() + value.slice(1);
}